module.exports = __webpack_public_path__ + "img/shutter-rename.42716e89.svg";